import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { BooleanParam, StringParam, useQueryParam, withDefault } from 'use-query-params';
import { Box, Container, Grid} from '@mui/material';
import { ChatModel } from 'models/ChatModel';
import ChatList from 'modules/chats/common/ChatList';
import Chat from 'modules/chats/common/Chat';
import { useChats } from 'modules/chats/hooks/useChats';
import app from 'recoil/atoms/app';


const Chats = () => {
    const setApp = useSetRecoilState(app);
    const [code, setCode] = useQueryParam('chat', StringParam);
    const [closed, setClosed] = useQueryParam('closed', withDefault(BooleanParam, false));
    const {chats, closeChat} = useChats(closed);

    useEffect(() => {
        setApp(old => ({...old, chatUnread: 0}));
    }, []);
    const Layout = isMobile ? MobileChats : DesktopChats;
    const currentChat = chats.find(c => c.code === code);

    return <Layout
        chats={chats}
        current={currentChat}
        closeChat={closeChat}
        setClosed={setClosed}
        setCurrent={setCode}
    />;
};

type LayoutProps = {
    chats: ChatModel[],
    current?: ChatModel,
    closeChat: (code: string) => void,
    setClosed: (v: boolean) => void,
    setCurrent: (v: string) => void,
}

const MobileChats = ({chats, current, setCurrent, setClosed, closeChat}: LayoutProps) => {
    const navigate = useNavigate();
    return (
        <Box height="calc(100vh - 48px)">
            {current ?
                <Chat
                    key={current.code}
                    onClose={() => navigate(-1)}
                    code={current.code}
                    name={current.name}
                /> :
                <ChatList
                    chats={chats}
                    current={current}
                    closeChat={closeChat}
                    setCurrent={setCurrent}
                />
            }
        </Box>
    )
};

const DesktopChats = ({chats, current, setCurrent, setClosed, closeChat}: LayoutProps) => {
    return (
        <Container maxWidth="lg">
            <Grid container columnSpacing={2} height="calc(100vh - 48px)">
                <Grid item sm={4} maxHeight="100%">
                    <ChatList
                        chats={chats}
                        current={current}
                        closeChat={closeChat}
                        setCurrent={setCurrent}
                    />
                </Grid>
                <Grid item sm={8} maxHeight="100%">
                    {current ?
                        <Chat
                            key={current.code}
                            code={current.code}
                            name={current.name}
                        /> :
                        <Box
                            sx={{
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                fontSize: '2rem',
                                color: 'text.disabled',
                            }}
                        >Select chat</Box>
                    }
                </Grid>
            </Grid>
        </Container>
    )
};

export default Chats;
